import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';

/* global customElements, Intl */
class FileManagementGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
		
		var fileManagementGrid = this;
		setTimeout(function(){
			fileManagementGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var fileManagementGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [				
				{
					tag: 'vaadin-text-field',
					itemid: 'path',
					label: 'Path',
					name: 'path',
					style: 'margin-left: 5px; width: 500px;',
					maxLength: 1024
				},
				{
					tag: 'vaadin-button',
					itemid: 'Navigate',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:arrow-circle-right', ' Navigate')
					], 
					listeners: {
						click: function() {
							actionRefresh(grid.selectedItems && grid.selectedItems.length >= 1 ? grid.selectedItems[0] : null);
						}
					}
				},
				{
					tag: 'vaadin-checkbox',
					itemid: 'noSize',
					value: 'true',
					label: 'No Size'				
				},
				{
					tag: 'vaadin-checkbox',
					itemid: 'noLastModified',
					value: 'true',
					label: 'No Last Modified'	
				},
				{
					tag: 'hr'					
				},
				{
					tag: 'dl-toolbar',
					theme: 'spacing',
					children: [
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',										
							permissions: ['ADMIN_SYSTEM:READ'],
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Upload')
							],
							listeners: {
								click: function() {							
									actionUpload();
								}
							}
						},
						{
							tag: 'span',
							'class': 'spacer-toolbar-item',
							style: 'font-size: 24px; color: gray;',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'download',
							disabled: true,
							'class': 'spacer-toolbar-item',										
							permissions: ['ADMIN_SYSTEM:READ'],
							children:[
								ElementUtil.makeIcon('vaadin:download', ' Download')
							],
							listeners: {
								click: function() {							
									actionDownload(grid.selectedItems[0], false);
								}
							}
						},				
						{
							tag: 'dl-action-button',
							itemid: 'download-cmp',
							disabled: true,
							'class': 'spacer-toolbar-item',										
							permissions: ['ADMIN_SYSTEM:READ'],
							children:[
								ElementUtil.makeIcon('vaadin:download', ' Download (Decompress)')
							],
							listeners: {
								click: function() {							
									actionDownload(grid.selectedItems[0], true);
								}
							}
						},				
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['ADMIN_SYSTEM:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
								
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [				
				{						
					path: 'name',
					header: 'File Name',					
					width: '9em'
				},
				{						
					path: 'directory',
					header: 'Type',
					width: '9em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {	
						root.innerHTML = rowData.item.directory ? 'Directory' : 'File';					
					}					
				},
				{						
					path: 'size',
					header: 'Size',
					width: '9em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {	
						if (!rowData.item.directory) {
							root.innerHTML = new Intl.NumberFormat().format(rowData.item.size);
						} else {
							root.innerHTML = '';
						}
					}					
				},
				{						
					path: 'lastModifyDate',
					header: 'Last Modified',
					width: '9em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						if (rowData.item.lastModifyDate) {
							var date = TimeUtil.parseDate(rowData.item.lastModifyDate);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = '';
						}
					}					
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'download').disabled = true;
						ElementUtil.query(toolbar, 'download-cmp').disabled = true; 
						ElementUtil.query(toolbar, 'delete').disabled = true;
						
						if (grid.selectedItems[0].directory) {
							
						} else {
							ElementUtil.query(toolbar, 'download').disabled = false; 
							ElementUtil.query(toolbar, 'download-cmp').disabled = false; 
							ElementUtil.query(toolbar, 'delete').disabled = false;
						}
					} else {
						ElementUtil.query(toolbar, 'download').disabled = true;
						ElementUtil.query(toolbar, 'download-cmp').disabled = true; 
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});	
		
		var getPath = function() {
			var path = ElementUtil.query(toolbar, 'path').value;
			path = path || '';
			return path;
		};		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 500,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					//options
					var noSizeChk = ElementUtil.query(toolbar, 'noSize');
					var noLastChk = ElementUtil.query(toolbar, 'noLastModified');
					
					fileManagementGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						noSize: noSizeChk.checked ? noSizeChk.value : false,
						noLastModified: noLastChk.checked ? noLastChk.value : false
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;	
						
						//if not the root path then add .. to go up one directory
						var currentPath = getPath();
						
						var displayData = records.data;
						if (currentPath && currentPath !== '' && currentPath !== '/' && currentPath !== '\\') {
							displayData.splice(0,0, {
								"name": "..",
								"directory": true,
								"rootDirectory": false,
								"directoryPath": "",
								"size": 0,
								"lastModifyDate": null
							});
						}
						
						grid.items = displayData;
						
						fileManagementGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					Service.getFileService().getFiles(getPath(), fileManagementGrid.currentFilter).then(function(data){
						loadMask.remove();						
						successHandler(data);			
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		fileManagementGrid.append(flexLayout);
				
		var actionRefresh = function(record) {
			if (record && record.directory) {
				
				var path = getPath();
				if (record.name === '..') {
					var parts = path.split('/');
					if (parts.length === 2) {
						path = '';
					} else {
						parts = parts.slice(0, parts.length-1);
						path = parts.join('/');
					}
				} else {				
					path += '/' + record.name;						
				}
				ElementUtil.query(toolbar, 'path').value = path;
			}
			
			pagingToolbar.loadPage(1);
		};

		var actionExport = function() {
			var exportFilter = Object.assign({}, fileManagementGrid.currentFilter || {});
			delete exportFilter.offset;
			delete exportFilter.max;
			Service.getFileService().exportFiles(getPath(), exportFilter);
		};

		var actionUpload = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Upload File',
				icon: 'vaadin:upload',
				width: 450,
				height: 320,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
														
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A resource File is required.');
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [									
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 10,
										required: true,
										target: '/api/resource/files',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-before': function(event) {
												var file = event.detail.file;												
												var data = uploadFormPanel.getData();												
												
												var params = '?directory='+ encodeURIComponent(getPath());
												if (data.compress) {
													params += '&compress=true';
												}
												
												//event.detail.formData.append('uniqueName', data.uniqueName);
												file.uploadTarget = '/api/resource/files/upload' + params;												
											},
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													//error 
													window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
													);
												} else {
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},
									{
										tag: 'vaadin-form-layout',										
										children: [
											{
												tag: 'vaadin-checkbox',
												label: 'Compress',												
												name: 'compress',																																				
												colspan: 2
											}, 
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}				
				
			});	
		};
	
		var actionDownload = function(record, decompress) {			
			var options ={
				decompress: decompress
			};
			Service.getFileService().downloadFileObject(record.directoryPath, record.name, options);
		};
	
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete: ' + record.name + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing file...');
							
							var success = function() {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed: ' + record.name, {									
									theme: 'success'
								});
								actionRefresh();
							};							
							
							Service.getFileService().deleteFile(record.directoryPath, record.name).then(function(){
								success();
							});		
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
		
	}	
	
};
customElements.define('dl-file-management', FileManagementGrid);